import { useEffect, useState } from 'react';
import { authApi } from '@/pages/public/auth/auth-api';

/**
 * Whether the current user has an email/password credential. Social-only sign-ups (Google/Facebook/
 * LinkedIn) have none, so the UI can drop the "current password" field and use a verification-based
 * flow instead of demanding a password the account never set.
 *
 * `hasPassword` is `undefined` until the accounts load (and stays `undefined` if the lookup fails, so
 * callers can fall back to the safe password-required path).
 */
export function useHasPassword(): { hasPassword: boolean | undefined; loading: boolean } {
    const [hasPassword, setHasPassword] = useState<boolean | undefined>(undefined);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        authApi
            .listAccounts()
            .then((accounts) => {
                if (active) {
                    setHasPassword(accounts.some((account) => account.providerId === 'credential'));
                }
            })
            .catch(() => {
                if (active) {
                    setHasPassword(undefined);
                }
            })
            .finally(() => {
                if (active) {
                    setLoading(false);
                }
            });
        return () => {
            active = false;
        };
    }, []);

    return { hasPassword, loading };
}
